import './Menu.css'
import React, { useState } from 'react'
import Sidebar from '../../Components/SideBar/index'
import ScrollToTop from '../../Components/ScrollToTop'
import Index2 from '../../Components/Navbar2/index2'
import Footer from '../../Components/Footer/Footer'
import InfoSection3 from '../../Components/Infosection3/Index3'
import { homeObjOne3 } from '../../Components/Infosection3/Data3'

const MenuFra = () => {
  const [isOpen, setIsOpen] = useState(false)
      
     const toggle = () => {
      setIsOpen(!isOpen)
     }
  return (
    <>
      <ScrollToTop />
      <div className='HeroContainer_menu'>
        <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='Hero_menu'>
          <Index2 toggle={toggle}/>
        </div>
      </div>
      <InfoSection3 {...homeObjOne3}/>
      <div className='menu_con'>
        <div className='menu_title'>
          Vår Meny
        </div>
         <div className='pris'>
          För mer info kontakta gärna 
          <br />
          076 413 08 53
          <br />
          cateringbyprestig@gmail.com
        </div>
      </div>
                <br />
      <br /><br />
      <div className='menu'>
        <div className='menu_pic'>
          <div className='grid-container'>
            <div className='card_con'>
                <div className='wrapper'>
                <br /><br />
                    <div className='card_area'>
                        <div className='card'>
                        <div className='meny_title'>
                            FRANSKA KALLA DELIKATESSER
                        </div><br /><br />
                        <div className='menu_mat'>
                            Terrine de campagne med cornichons & dijonsenap.
                            <br /><br />
                            Rostbiff med dijonsenap & örter.
                            <br /><br />
                            Fransk kycklingterrine med örter.
                            <br /><br />
                            Rökt lax med citron, dill & crème fraîche.
                            <br /><br />
                            Räkor med citron & örter.
                            <br /><br />
                            Fransk potatissallad med dijon, kapris & färska örter.
                            <br /><br />
                            Ratatouille serverad kall med extra virgin olivolja.
                            <br /><br />
                            Haricots verts med schalottenlök & vinägrett.
                            <br /><br />
                            Rödbetssallad med chèvre & valnötter.
                            <br /><br />
                            Grönsallad med fransk dijonvinägrett.
                        </div>
                        </div>
                        <div className='card'>
                        <div className='meny_title'>
                            FRANSK OSTBUFFÉ
                      </div><br /><br />
                      <div className='menu_mat'>
                        Brie de Meaux.
                        <br /><br />
                        Camembert.
                        <br /><br />
                        Comté.
                        <br /><br />
                        Chèvre.
                        <br /><br />
                        Roquefort.
                        <br /><br />
                        Vindruvor, päron & fikon.
                        <br /><br />
                        Valnötter.
                        <br /><br />
                        Fikonmarmelad & honung.
                      </div> 
                    </div>              
                    <div className='card'>
                        <div className='meny_title'>
                        FRANSKT BRÖD
                        </div><br /><br />
                    <div className='menu_mat'>
                        Färsk baguette
                        <br /><br />
                        Surdegsbröd
                        <br /><br />
                        Croissant salé
                        <br /><br />
                        Franska crackers
                        <br /><br />
                        Vispat örtsmör
                    </div>
                    </div>
                    <div className='card'>
                    <div className='meny_title'>
                        VARMA FRANSKA KLASSIKER
                        </div><br /><br />
                        <div className='menu_mat'>
                            Coq au Vin – klassisk fransk kycklinggryta med rödvin, champinjoner & örter.
                            <br /><br />
                            Boeuf Bourguignon – långkokt nötkött med rödvin, champinjoner & små lök.
                            <br /><br />
                            Gratinerad potatis à la Dauphinoise.
                            <br /><br />
                            Rostade rotfrukter med timjan.
                            <br /><br />
                            Haricots verts med vitlök & örter.
                        </div>
                        </div>
                        <div className='card'>
                        <div className='meny_title'>
                            FRANSKA SALLADER & TILLBEHÖR
                        </div><br /><br />
                        <div className='menu_mat'>
                            Salade Niçoise med tonfisk, ägg, haricots verts & oliver.
                            <br /><br />
                            Fransk linssallad med dijon & färska örter.
                            <br /><br />
                            Tomatsallad med schalottenlök & basilika.
                            <br /><br />
                            Cornichons & små picklade grönsaker.
                        </div>
                        </div>
                        <div className='card'>
                            <div className='meny_title'>
                                FRANSKA DESSERTER
                            </div><br /><br />
                        <div className='menu_mat'>
                            Klassisk Crème brûlée.
                            <br /><br />
                            Chokladmousse.
                            <br /><br />
                            Tarte aux pommes.
                            <br /><br />
                            Mini-éclairs.
                            <br /><br />
                            Franska macarons.
                            <br /><br />
                            Färska bär.
                            <br /><br />
                        </div>
                        </div>
                        
                  </div>             
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  )
}

export default MenuFra